import React from 'react';
import { whyChooseUs } from '../utils/mockData';
import { 
  TrendingUp, 
  Users, 
  Truck, 
  CreditCard, 
  Zap 
} from 'lucide-react';

const iconMap = {
  TrendingUp,
  Users,
  Truck,
  CreditCard,
  Zap
};

const WhyUsSection = () => {
  return (
    <section id="why-us" className="py-24 bg-gray-50 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-manufacturing-orange rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-bharat-blue rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-manufacturing-orange/10 text-manufacturing-orange px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Why Choose Us
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-bharat-blue mb-6">
            Why Manufacturers Choose Bharat Enterprises
          </h2>
          <p className="text-xl text-steel-grey max-w-3xl mx-auto">
            Built on trust, powered by expertise, and driven by your success
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <div 
                key={item.id}
                className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 group border-t-4 border-manufacturing-orange hover:-translate-y-2"
              >
                {/* Icon */}
                <div className="relative mb-6">
                  <div className="w-16 h-16 bg-bharat-blue rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-manufacturing-orange rounded-full flex items-center justify-center text-white text-sm font-bold">
                    {index + 1}
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-bharat-blue mb-3">
                  {item.title}
                </h3>
                <p className="text-steel-grey leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA Card */}
        <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 shadow-xl border-2 border-gray-100">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-bharat-blue mb-4">
                Ready to Partner with Us?
              </h3>
              <p className="text-lg text-steel-grey mb-6">
                Experience the Bharat Enterprises difference. Let's discuss how we can support 
                your manufacturing needs with reliable TiO₂ supply and competitive pricing.
              </p>
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-industrial-green rounded-full"></div>
                  <span className="text-steel-grey">Fast Response Time</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-industrial-green rounded-full"></div>
                  <span className="text-steel-grey">Transparent Pricing</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-industrial-green rounded-full"></div>
                  <span className="text-steel-grey">Quality Assurance</span>
                </div>
              </div>
            </div>
            <div className="flex justify-center">
              <img 
                src="/logo-secondary-blue.png" 
                alt="Bharat Enterprises"
                className="max-w-xs w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
